const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
    data() {
        return {
            vRules: {
                alpha: val => /[a-zA-Z0-9]/.test(val) || `This field can only contain alphanumeric characters`,
                numeric: val => !isNaN(val) || `This field must be a number`,
                multipleOf: (multiple) => val => val % multiple == 0 || `This field must be a multiple of ${multiple}`,
                lengthMultipleOf: (multiple) => val => val && (val.length % multiple == 0) || `This field's character count must be a multiple of ${multiple}`,
                regex: (pattern, message = null) => val => pattern.test(val) || message || `The value does not match the specified format`,
                between: (min, max) => val => parseFloat(val) >= parseFloat(min) && parseFloat(val) <= parseFloat(max) || `This field must be between ${min} and ${max}`,
                gte: (min) => val => parseFloat(val) >= parseFloat(min) || `This field must be greater than or equal to ${min}`,
                lte: (max) => val => parseFloat(val) <= parseFloat(max) || `This field must be less than or equal to ${max}`,
                differentTo: (otherValue, name) => val => val != otherValue || `This field must be different to ${name}`,
                sameAs: (otherValue, name) => val => val == otherValue || `This field must be the same as ${name}`,
                minLength: (minLength) => val => val && val.length >= minLength || `This field must be at least ${minLength} characters long`,
                maxLength: (maxLength) => val => val && val.length <= maxLength || `This field length must be less than or equal to  ${maxLength} characters long`,
                exactLength: (length) => val => val && val.length == length || `This field must be exactly ${length} characters long`,
                valid: val => val.valid === true,
                required: val => !!val || val === 0 || val === false || `This field is required`,
                checked: val => val === true || `This field is required`,
                email: val => emailRegex.test(val) || "Please enter a valid email address",
                url: val => {
                    let url;
                    let message = "Please enter a valid URL";

                    try {
                        url = new URL(val);
                    } catch (e) {
                        return message;
                    }

                    return (url.protocol === "http:" || url.protocol === "https:") || message;
                }
            }
        }
    }
}
